export enum KisType {
    Care2U = 'Care2U',
    CareSharing = 'CareSharing',
    PortaVita = 'PortaVita',
    TeleDia = 'TeleDia',
}
